export const emailOtp = async (sendOtp) => {
    console.log("JSON.stringify(sendOtp)"); 
    try {
      console.log(JSON.stringify(sendOtp)); 
      console.log("Request body:", sendOtp);
      // http://localhost:5000
      const response = await fetch('https://blog-swipe-backend.vercel.app/sendOtp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Ensure the server knows it's JSON
        },
        body: JSON.stringify(sendOtp), 
     
         // Send the sendOtp object as a JSON string
      });
      
      console.log("Registration data:", sendOtp);
  
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to register');
      }
  
      const result = await response.json();
      return result;
    } catch (error) {
      alert('Error sending otp:', error);
      throw error;
    }
  };
  